import type { CompanyInfo } from 'common/types/company';
import type { CurrencyCode } from 'common/types/format';

export const getWaterfallSourceCurrency = (
  companyInfo: CompanyInfo | null | undefined,
  companyId: number | null | undefined,
  page: string
): CurrencyCode | undefined => {
  const sourceCurrency = companyInfo?.[`${page}_currency`];
  if (
    companyId == null ||
    Number(companyInfo?.id) !== Number(companyId) ||
    typeof sourceCurrency !== 'string' ||
    sourceCurrency.length === 0
  ) {
    return undefined;
  }
  return sourceCurrency as CurrencyCode;
};

export const getEffectiveWaterfallExchangeRate = ({
  sourceCurrency,
  selectedCurrency,
  exchangeRateFromUrl,
  fetchedExchangeRate,
  shouldFetchExchangeRate,
}: {
  sourceCurrency?: CurrencyCode;
  selectedCurrency: CurrencyCode;
  exchangeRateFromUrl?: number;
  fetchedExchangeRate?: number;
  shouldFetchExchangeRate: boolean;
}): number | null => {
  if (!sourceCurrency) {
    return null;
  }
  if (sourceCurrency === selectedCurrency) {
    return 1;
  }
  return exchangeRateFromUrl ?? (shouldFetchExchangeRate ? (fetchedExchangeRate ?? null) : null);
};
